import axios from 'axios';

export default {
    getEnrollments() {
        const options = {
            url: window.apiUrl + '/enrollments',            
            params: {
                // cache: 'enrollments'
            },
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getGroupInfo(context, groupId, week, term) {
        var options = {
            url: window.apiUrl + '/group/' + groupId + '?week=' + week + '&term=' + term,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getGroups(context, supervisorGroups) {
        let url = window.apiUrl + '/all-groups'
        if (supervisorGroups) url += '?group_ids=' + supervisorGroups
        var options = {
            url: url,
            params: {
                // cache: 'groups'
            },
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getInfo(context, studentId, termId) {
        var options = {
            url: window.apiUrl + '/student/' + studentId + '?term='+termId,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getProgression(context, uuid, week, instances) {
        
        let url = window.apiUrl + '/progression/' + uuid + '?week=' + week;
        
        if (instances) url += '&instances=' + instances;

        var options = {
            url: url,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    get(context) {
        var options = {
            url: window.apiUrl + '/students',            
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    evaluate(context, data) {
        var options = {
            method: 'PUT',
            url: window.apiUrl + '/evaluation',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data: data
            
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/students/index.js